/**
 * Highlights a specific event date when redirected from a duplicate event
 * Uses the from_duplicate URL parameter to identify which date to highlight
 */
function highlightDuplicateEvent() {
  // Get the from_duplicate parameter from URL
  const urlParams = new URLSearchParams(window.location.search);
  const fromDuplicate = urlParams.get('from_duplicate');

  if (!fromDuplicate) {
    return; // No highlighting needed
  }

  // Find the event date element with matching ID
  const eventElement = document.getElementById(`event-${fromDuplicate}`);

  if (!eventElement) {
    return; // Element not found
  }

  // Add initial highlighting styles
  eventElement.style.fontWeight = 'bold';
  eventElement.style.backgroundColor = '#fff3cd'; // Bootstrap warning color background
  eventElement.style.paddingLeft = '8px';
  eventElement.style.paddingRight = '8px';
  eventElement.style.borderRadius = '4px';
  eventElement.style.transition = 'background-color 1s ease-out';

  // Add a subtle border
  eventElement.style.border = '2px solid #ffc107'; // Bootstrap warning color

  // Scroll to the highlighted event
  eventElement.scrollIntoView({
    behavior: 'smooth',
    block: 'center'
  });

  // Remove highlight after 3 seconds with fade effect
  // Commented out to keep highlight visible
  // setTimeout(() => {
  //   eventElement.style.backgroundColor = 'transparent';
  //   eventElement.style.border = '2px solid transparent';

  //   // Remove bold font after transition completes
  //   setTimeout(() => {
  //     eventElement.style.fontWeight = '';
  //     eventElement.style.paddingLeft = '';
  //     eventElement.style.paddingRight = '';
  //     eventElement.style.borderRadius = '';
  //     eventElement.style.transition = '';
  //   }, 1000);
  // }, 3000);
}

// Run when DOM is ready
document.addEventListener('DOMContentLoaded', highlightDuplicateEvent);
